import { render, staticRenderFns } from "./sendHokl.vue?vue&type=template&id=25a89aaf&scoped=true"
import script from "./sendHokl.vue?vue&type=script&lang=js"
export * from "./sendHokl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a89aaf",
  null
  
)

export default component.exports